// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { v4 as uuid } from 'uuid'
import { getAuthorName } from '../../utils/common'
import VisitRemarksCardItem from '../VisitRemarksCardItem/VisitRemarksCardItem'

export const VisitRemarksContent = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  remarks,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setEditRemarkId,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setDeleteRemarkId,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isFormOpened,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  userTimeZoneAbbr,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  userTimeZone,
}) =>
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  remarks?.remarksList?.map((remark) => {
    const key = uuid()
    return (
      <VisitRemarksCardItem
        key={key}
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        isEdited={remark?.IsEdited}
        userTimeZoneAbbr={userTimeZoneAbbr}
        dateTime={remark?.DateTime}
        message={remark?.Message}
        author={getAuthorName(remark?.Author, false)}
        role={remark?.Author?.UserType}
        index={remark?.RemarkId}
        isEditAllowed={remark?.IsEditAllowed}
        setEditRemarkId={setEditRemarkId}
        setDeleteRemarkId={setDeleteRemarkId}
        userTimeZone={userTimeZone}
        isFormOpened={isFormOpened}
      />
    )
  })
